import {HttpClient, expectEither} from '@raison/network-facade';
import {Action} from '@reduxjs/toolkit';
import {CriticalErrorMsg} from '~/entities/dialogs/ui/CriticalErrorMsg';
import {balancesRoutine} from '~/redux/balances/balancesRoutine';
import {onlyLeading} from '~/shared/utils/for-redux';
import {BalancesSchema} from './balancesTypes';

async function balancesEffect(_: Action, api: AppEffectAPI) {
    const http = api.extra.http;
    const {status, json} = await fetchBalances(http).catch(error => {
        api.dispatch(balancesRoutine.failure(error));
        api.dispatch(CriticalErrorMsg.open());
        throw error;
    });

    if (status === 'Abort') {
        return;
    }

    api.dispatch(balancesRoutine.success(json));
}

export default function (startListening: AppStartListening) {
    startListening({
        actionCreator: balancesRoutine.trigger,
        effect: onlyLeading(balancesEffect),
    });
}

function fetchBalances(http: HttpClient) {
    return http('/v1/instruments/balances').then(
        ...expectEither({
            200: BalancesSchema,
        })
    );
}
